import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import { useStyles } from "components/request-document/components/Commons";
import UploadDucument from "components/request-document/components/UploadDucument";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import {
  EXTENSION_DOCUMENT_STEP,
  VISA_TYPE_ID,
  VISA_TYPE_NAME,
} from "libs/configs/constant";
import { SMART_NAME_ALIAS } from "libs/constant/smartForm";
import { HOME_TAB } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearSmartFormStep, setHomeTab } from "redux/modules/uiSlice";
import {
  addExtensionSlice,
  documentRequiredSlice,
  getDocumentRequired,
  selectAddExtension,
  submitSmartForm,
  submitSmartFormSlice,
} from "redux/modules/visaForm";

export default function PartUploadDucument() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isSaveDraft, setSaveDraft] = useState(false);
  const { showLoading, hideLoading } = useModalLoading();

  const { smartserviceId } = useSmartService();
  const { personalId } = usePersonalDetail();
  const { draftId, submitSmartFormState, getSmartForm, smartform } =
    useSmartForm();
  const addExtensionState = useSelector(selectAddExtension);

  const smartserviceReferId = get(smartform, "smartserviceReferId");
  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(smartform, "detail", []).reduce(
    smartNameById,
    {}
  );
  const conditionType = get(smartformDetail, "ConditionType.value", "");
  const ConditionType =
    smartserviceReferId === VISA_TYPE_ID.SMART_S
      ? conditionType
      : SMART_NAME_ALIAS[VISA_TYPE_NAME[smartserviceReferId]];

  useEffect(() => {
    if (smartserviceId) {
      getSmartForm({
        smartserviceId,
        draftId,
        personalId,
      });
    }
  }, [dispatch, draftId, getSmartForm, personalId, smartserviceId]);

  useEffect(() => {
    if (smartserviceReferId) {
      dispatch(
        getDocumentRequired({
          smartserviceId: "ea67ab08-5953-4453-0830-28ed243a8d38",
          ConditionType: ConditionType,
        })
      );
    }
  }, [dispatch, smartserviceReferId, ConditionType]);

  useEffect(() => {
    if (addExtensionState.isLoading) {
      showLoading();
    } else if (!addExtensionState.isLoading) {
      if (addExtensionState.isSuccess) {
        dispatch(addExtensionSlice.actions.clearAsyncState());
        dispatch(submitSmartForm({ draftId }));
        dispatch(documentRequiredSlice.actions.clearAsyncState());
      } else if (addExtensionState.isFailure) {
        hideLoading();
        alert(addExtensionState.error?.message);
        dispatch(addExtensionSlice.actions.clearAsyncState());
      }
    }
  }, [addExtensionState, dispatch, draftId, hideLoading, showLoading]);

  useEffect(() => {
    if (!submitSmartFormState.isLoading) {
      if (submitSmartFormState.isSuccess) {
        hideLoading();
        dispatch(submitSmartFormSlice.actions.clearAsyncState());

        if (!isSaveDraft) {
          dispatch(clearSmartFormStep());
          dispatch(setHomeTab(HOME_TAB.INFORMATION));
        } else {
          getSmartForm({
            smartserviceId,
            draftId,
            personalId,
          });
        }
      } else if (submitSmartFormState.isFailure) {
        hideLoading();
        alert(submitSmartFormState.error?.message);
        dispatch(submitSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    dispatch,
    hideLoading,
    submitSmartFormState.error?.message,
    submitSmartFormState.isFailure,
    submitSmartFormState.isLoading,
    submitSmartFormState.isSuccess,
  ]);

  return (
    <div className={classes.root}>
      <ContentTitle
        title="APPLICATION FOR SMART VISA EXTENSION"
        subTitle="SMART VISA EXTENSION"
      />
      <Steper isExtend currentStep={1} stepInfo={EXTENSION_DOCUMENT_STEP} />
      <UploadDucument isExtension setSaveDraft={setSaveDraft} />
    </div>
  );
}
